//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { DataProvider, LocalizationHelper } from "../helpers"

import { SESSION, SESSION_ERROR } from "../models/custom"
import { Enums } from "../models/common"


export class DataProviderHttp {

    // #eegion Ctor

    constructor(private dataProvider: DataProvider) { }

    // #endregion

    // #region Public Methods

    public sendRequest = (method: string, data: any, sessionField: string = null, resultField: string = null, ignoreResultField: boolean = false): JQueryPromise<any> => {
        var deferred = $.Deferred<any>()

        $.ajax({
            type: 'POST',
            url: DataProvider.URL + method,
            data: JSON.stringify(data),
            dataFilter: (data: string, type: string) => {
                return data
            },
            success: (response) => {
                if (sessionField) {
                    const session: SESSION = new SESSION(response[sessionField])

                    if (session) {
                        if (sessionField !== 'LoginResult' && (session.status == Enums.SESSION_STATUS.LOGIN_NOT_VALID || session.status == Enums.SESSION_STATUS.SESSION_NOT_VALID)) {
                            this.dataProvider.Session.logout()
                            deferred.reject(session)
                        }
                        else if ((session.error && session.error.msg) || session.status == Enums.SESSION_STATUS.ERROR) {
                            deferred.reject(session)
                        }
                        else {
                            if (resultField && typeof response[resultField] !== 'undefined') {
                                if (ignoreResultField) {
                                    deferred.resolve(response)
                                } else {
                                    deferred.resolve(response[resultField])
                                }
                            } else if (resultField) {

                                //!!!TODO Zmienić "Problem with api" na 'Skontaktuj się z adminem...' i dodać error code
                                session.error = new SESSION_ERROR({
                                    Msg: this.prepareGenericeErrorMessage()
                                })

                                deferred.reject(session)
                            } else {
                                deferred.resolve(response[sessionField])
                            }
                        }
                    } else {
                        session.error = new SESSION_ERROR({
                            Msg: this.prepareGenericeErrorMessage()
                        })
                        deferred.reject(session)
                    }
                } else {
                    deferred.resolve(response)
                }
            },
            error: e => {
                const session: SESSION = new SESSION(null)

                session.guid = '00000000-0000-0000-0000-000000000000'
                session.error = new SESSION_ERROR({
                    Msg: this.prepareGenericeErrorMessage(e)
                })

                deferred.reject(session)
            },
            processData: false,
            contentType: 'application/json',
        })

        return deferred.promise()
    }

    // #endregion

    // #region

    private prepareGenericeErrorMessage = (error: any = null): string => {
        let errorMessage: string = null

        try {
            errorMessage = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator)

            if (error && error.status) {
                errorMessage += `<br/><center>(${error.status})</center>`
            }
        } catch (e) {
            try {
                console.log(e)
            } catch (ie) {
                // ignored
            }

            errorMessage = "An error occured..."
        }

        return errorMessage
    }

    // #endregion
}